export const setAttribute = (attribute, value, stopTrying = false) => {
  if (!!window.OptiMonkEmbedded && !!window.OptiMonkEmbedded.Visitor) {
    const adapter = window.OptiMonkEmbedded.Visitor.createAdapter();
    adapter.attr(attribute, value);
  } else if (!stopTrying) {
    setTimeout(() => {
      setAttribute(attribute, value, true);
    }, 2000);
  }
};

export const optimonkSetCart = (items, stopTrying = false) => {
  if (!!window.OptiMonkEmbedded && !!window.OptiMonkEmbedded.Visitor) {
    var OM = window.OptiMonkEmbedded;
    var adapter = OM.Visitor.createAdapter();
    adapter.Cart.clear();
    for (let item of items) {
      adapter.Cart.add(`${item.id}`, {
        quantity: item.quantity,
        price: item.price,
      });
    }
  } else if (!stopTrying) {
    setTimeout(() => {
      optimonkSetCart(items, true);
    }, 2000);
  }
};
